import { configureStore } from '@reduxjs/toolkit'
import rerenderSlice from "./reducers/rerenderSlice";


export default configureStore({
  reducer: {
    rerender: rerenderSlice,
  },
})